export const emailSignature = '@dalmadaniela.com'

export const adminEmails = [
    `dalma${emailSignature}`,
    `camireyes${emailSignature}`,
    `corey${emailSignature}`,
    'angelusproductions@gmail.com'
]